import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var WarningError = function WarningError(message) {
  _classCallCheck(this, WarningError);

  this.message = message;
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/warning.js
// module id = ./src/abstractions/errors/warning.js
// module chunks = 34